import { Device } from './device';
import { AdditionalInfoImpl } from './status/additional-info-impl';

export class DeviceWithStatus {
    constructor(
      public device: Device,
      public status: AdditionalInfoImpl
    ) {}
}
